import { isClientPayingSubscriber, isClientSubscribed } from '@frontend/api-client';
import { showToast } from '@frontend/web-react';
import { useRetrieveClientQuery, useRetrieveClientStatusQuery } from '@frontend/web/hooks/api';
import { useRouter } from '@tanstack/react-router';

export const useAccessControl = () => {
  const { data: clientStatus, isLoading: isClientStatusLoading } = useRetrieveClientStatusQuery();
  const { data: client } = useRetrieveClientQuery();

  const router = useRouter();

  const checkAccessAndRedirect = () => {
    if (!isClientSubscribed(clientStatus) && !isClientStatusLoading) {
      showToast({
        title: 'You need an active subscription to access this feature.',
        variant: 'warning',
      });
      router.history.back();
      return;
    }
    return;
  };

  return {
    checkAccessAndRedirect,
    isAccessControlLoading: isClientStatusLoading,
    isClientPayingSubscriber: isClientPayingSubscriber({ client, clientStatus }),
    isClientSubscribed: isClientSubscribed(clientStatus),
  };
};
